export const recuerdos = [
  {
    id: 'apertura',
    label: 'AÑOS 90',
    title: 'El día de la inauguración',
    description:
      'La tienda llena de gente, la mesa con el picoteo y las copas, y esa mezcla de nervios y alegría de estrenar un espacio propio.',
    image:
      'https://storage.helloreaddy.io/project_files/fa9241bd-708b-4ac3-86f9-96ae8f927366/a6b3d83a-4153-4d63-87da-e63a36f494ad_compressed_737E93A6-BF47-4DEE-821E-E4A27D8788B5.webp',
    alt: 'Inauguración histórica de la boutique SANO Moda en Llíria con clientas y percheros dorados',
    titleAttr: 'Inauguración de SANO Moda · Llíria, Valencia',
  },
  {
    id: 'mostrador',
    label: 'EL MOSTRADOR DE SIEMPRE',
    title: 'Donde todo se contaba',
    description:
      'Pocas cosas había más nuestras que aquel mostrador: la caja registradora, el expositor de collares y las flores que nunca faltaban.',
    image:
      'https://storage.helloreaddy.io/project_files/fa9241bd-708b-4ac3-86f9-96ae8f927366/19a2de12-11aa-4deb-85fd-c22516faf9ca_compressed_F264C2E2-42E6-4E3E-92FE-AB44DBDF24F1.webp',
    alt: 'Mostrador histórico de SANO Moda con caja registradora, joyas y flores',
    titleAttr: 'El mostrador de SANO Moda · Llíria, Valencia',
  },
  {
    id: 'calzado',
    label: 'AÑOS DE CALZADO Y FLORES',
    title: 'El rincón del zapato',
    description:
      'Empezamos también por el calzado. Estanterías llenas, un niño esperando a su madre y un ramo enorme recibiendo en la puerta.',
    image:
      'https://storage.helloreaddy.io/project_files/fa9241bd-708b-4ac3-86f9-96ae8f927366/11f71938-0536-415a-a055-c39acec01f0c_compressed_67F46E9E-3AA6-4A8D-A820-3BB8C2C2E170.webp',
    alt: 'Interior antiguo de la zapatería de SANO Moda con estanterías de calzado y flores',
    titleAttr: 'El rincón del calzado de SANO Moda · Llíria',
  },
  {
    id: 'prensa',
    label: 'PRENSA LOCAL',
    title: '«Comercios de la Comarca»',
    description:
      'El recorte que guardamos con más cariño: «Sano, Botiga Senyora i Caballero», en la Plaça 9 d\'Octubre, 1, y el segundo local en Pla de l\'Anc, 5. Un trocito de historia de Llíria.',
    image:
      'https://storage.helloreaddy.io/project_files/fa9241bd-708b-4ac3-86f9-96ae8f927366/eedcebdf-d586-4979-9b64-752a59b368a7_compressed_Captura-de-pantalla-2026-10-21-002341.webp',
    alt: 'Recorte de prensa antiguo Comercios de la Comarca con el anuncio de Sano, Botiga Senyora i Caballero, en Llíria',
    titleAttr: 'Recorte de prensa de Sano en Comercios de la Comarca · Llíria, Valencia',
  },
];